import * as React from "react";
import { Div } from "../../../../../../../react-core/Html/Div";
import { BankAccountCombinedResult } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccountCombinedResult";
import { BwaBranchDataReferral } from "../../../../../../../Wrap/Models/Domains/BankAccount/BwaBranchDataReferral";
import { ExperianMessageType } from "../../../../../../../Wrap/Models/Domains/BankAccount/ExperianMessageType";
import { VerificationResult } from "../../../../../../../Wrap/Models/Domains/BankAccount/VerificationResult";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Action } from "../../../../../Actions/Action";
import { BWABankAccountsStore } from "../../../PortfolioDashboard/Store/Variable";
import { inUseBankAccountForApply } from "../../PaymentsIn/BankAccount/BankAccountHelper";
import { processTypeEnum } from "../../Resource/Contents";
import { BWAMessages } from "../Resource/Content";

interface IBankAccountProps extends IProcessComponentProps {
    processType: processTypeEnum;
    data: any;
}

interface IBankAccountState {
    isShowBWvalidationMsg: boolean;
    BankAccountCheckResults: BankAccountCombinedResult[];
    isShowBWACheckMsg: boolean;
    BWACheckMsg: string;
    BWAValdiationMsg: string;
    continueBtnHaveClick: boolean;
}

export class BankAccountWarning extends ProcessComponent<IBankAccountProps, IBankAccountState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isShowBWvalidationMsg: false,
            BankAccountCheckResults: [],
            isShowBWACheckMsg: false,
            BWACheckMsg: null,
            BWAValdiationMsg: null,
            continueBtnHaveClick: false,
        };
        this.subscribeToStore(BWABankAccountsStore, () => this.onBWABankAccountsStoreChange());
    }

    componentDidMount() {
        super.componentDidMount();
        this.hasWarningMsg();
    }

    onBWABankAccountsStoreChange() {
        const data = BWABankAccountsStore.getData();
        this.setState({ BankAccountCheckResults: data });
    }

    isValid() {
        if (this.state.isShowBWvalidationMsg) {
            return false;
        }
        if (this.state.isShowBWACheckMsg && !this.state.continueBtnHaveClick) {
            this.props.showErrorMsgPopUp(["Please click Continue anyway button."], true);
            return false;
        }
        return super.isValid();
    }

    private hasWarningMsg(): void {
        const BankAccountCheckResults = BWABankAccountsStore.getData();
        const { data, processType } = this.props;

        if(processType == processTypeEnum.SinglePaymentTransfer || processType == processTypeEnum.RegularPayment) {
            return;
        }
        const inUseBankAccountInstructions = Array.from(new Set(inUseBankAccountForApply(data)));
        const id = data?.ClientDetails?.ActorId;
        Action.GetBankBranchData(id, 0, ExperianMessageType.Warning, (response: Array<BwaBranchDataReferral>) => {
            const result = [];
            inUseBankAccountInstructions?.forEach((val) => {
                const bwaBranchData = response?.find((ele) => ele.BankAccountNumber == val);
                const bankAccountInstruction = (data?.BankAccountInstructions as BankAccountInstruction[])?.find(
                    (f) => f.AccountNumber == val
                );
                if (bwaBranchData?.ValidationMessageCode == "5" && bankAccountInstruction?.NominatedForDirectDebit) {
                    result.push(bwaBranchData.BankAccountNumber + "-" + bwaBranchData.SortCode);
                }
            });

            this.setState({
                BWAValdiationMsg:
                    "The bank account(s) " +
                    result.join(",") +
                    " do not support Direct Debit Instructions." +
                    BWAMessages.BWAValidationMessage,
                isShowBWvalidationMsg: result.length > 0,
            });
        });

        const filterBankAccountCheckResults = BankAccountCheckResults?.filter(
            (f) =>
                f.BankAccountCheckResult.VerificationResult == VerificationResult.UnableToProcess ||
                f.BankAccountCheckResult.VerificationResult == VerificationResult.Refer ||
                f.BankAccountCheckResult.VerificationResult == VerificationResult.Fail ||
                f.BankAccountCheckResult.VerificationResult == VerificationResult.Unknown
        );
        const checkResult = [];
        filterBankAccountCheckResults?.forEach((val) => {
            checkResult.push(val.BankAccountCheckRequest.AccountNumber + "-" + val.BankAccountCheckRequest.SortCode);
        });
        this.setState({
            BWACheckMsg:
                "The bank account(s) " +
                checkResult.join(",") +
                " could not be authenticated for the client." +
                BWAMessages.BWACheckMessage,
            isShowBWACheckMsg: checkResult.length > 0,
        });
    }

    render() {
        const {
            isShowBWvalidationMsg,
            isShowBWACheckMsg,
            BWAValdiationMsg,
            BWACheckMsg,
            continueBtnHaveClick,
        } = this.state;
        return (
            <>
                {(isShowBWvalidationMsg || isShowBWACheckMsg) && (
                    <>
                        <h2>Bank Account(s) Checks</h2>
                        {isShowBWvalidationMsg && (
                            <Alert alertType={AlertType.Error} message={BWAValdiationMsg}></Alert>
                        )}
                        {isShowBWACheckMsg && (
                            <div>
                                <Alert alertType={AlertType.Warning} message={BWACheckMsg}></Alert>
                                <button
                                    className="btn secondary mr-12"
                                    disabled={continueBtnHaveClick}
                                    onClick={() => {
                                        this.setState({ continueBtnHaveClick: true });
                                    }}
                                >
                                    Continue anyway
                                </button>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }
}
